export const CERTIFICATION_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "Certification image",
    meta_title: "CFP® Global Certification",
    meta_title_color: "#222222",
    meta_priority: 1,
  },

  CERTIFICATION_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "layout_variant",
      label: "Layout Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Layout Variant",
      required: false,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1 (Default)", value: "variant_1" },
        { label: "Variant 2 (Poppins / Figma)", value: "variant_2" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "rgba(0, 212, 235, 0.33)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "rgba(0, 212, 235, 0.33)",
      required: false,
      defaultValue: "rgba(0, 212, 235, 0.33)",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "rgba(0, 0, 0, 0.66)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "rgba(0, 0, 0, 0.66)",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.66)",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "rgba(0, 0, 0, 0.66)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "rgba(0, 0, 0, 0.66)",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.66)",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "rgba(83, 69, 195, 0.46)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "rgba(83, 69, 195, 0.46)",
      required: false,
      defaultValue: "rgba(83, 69, 195, 0.46)",
    },
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "Graduate with globally recognized ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Pre Title",
      required: false,
      defaultValue: "Graduate with globally recognized ",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#222222CC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pre title color (e.g., #222222CC)",
      required: false,
      defaultValue: "#222222CC",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "certifications alongside your MBA.",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "certifications alongside your MBA.",
    },
    {
      fieldName: "title_start_color",
      label: "Title Start Color (Gradient)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_end_color",
      label: "Title End Color (Gradient)",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#00D4EB",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "title_gradient_direction",
      label: "Title Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 90deg, 180deg)",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "apply_now_text",
      label: "Apply Now Button Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Apply Now Button Text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "apply_now_button_start_color",
      label: "Apply Now Button Start Color (Gradient)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_button_end_color",
      label: "Apply Now Button End Color (Gradient)",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#00D4EB",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "button_gradient_direction",
      label: "Button Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 90deg, 180deg)",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "enable_button_shadow",
      label: "Apply Now Button Shadow",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable button drop shadow",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "apply_now_button_icon",
      label: "Apply Now Button Icon (Optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Apply Now Button Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "apply_now_button_icon_alt",
      label: "Alt Text for Apply Now Button Icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for button icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Left Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_text_left_nav_icon",
      label: "Alt Text for Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for left navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Right Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_text_right_nav_icon",
      label: "Alt Text for Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for right navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "scroll_frequency",
      label: "Scroll Frequency",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter scroll frequency (e.g., 3000)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Certification Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Certification",
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Certification Image",
      required: true,
    },
    {
      header: "Image Alt Text",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Text for Image",
      required: false,
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Certification Title",
      required: true,
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title Color",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],
};
